import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';

import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import globalSelectors from '../../../store/global-selectors';
import { useEnhancedReturnsContext } from './grids/enhanced-returns-context';
import { RETURNS_GRID_RELOAD } from '../../../constants/analytics-events';
import { Segment } from '../../../services/analytics-services/segment';

import { messages } from './messages';

import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {string} props.storeGuid
 * @returns {EnhancedReturnsHeader}
 */

export const EnhancedReturnsHeader = ({ storeGuid = '' }) => {
  const { onReload } = useEnhancedReturnsContext();
  const stores = useSelector(globalSelectors.selectSellerActiveStores);
  const store = stores.find((s) => s.storeGuid === storeGuid);

  const handleReload = useCallback(() => {
    Segment.trackEvent(RETURNS_GRID_RELOAD, {
      type: RETURNS_GRID_RELOAD,
      storeGuid,
    });

    onReload();
  }, [onReload, storeGuid]);

  return (
    <div className={styles['name-and-reload']}>
      <Text textType={TextType.H3} value={store.name} />
      <Button onClick={handleReload} theme='ghost'>
        <FontAwesomeIcon icon={faRedo} />
        <Text textType={TextType.Caption} value={messages.reload} />
      </Button>
    </div>
  );
};
